//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ImageUploader from "../../components/ImageUploader";
import {getRoom} from "../../api/room";

export default {
    name: "suggestForm",
    components: {ImageUploader},
    data() {
        return {
            active: '',
            radio: 0,
            value: '',
            repairParts: '',
            message: '',
            phone: '',
            fileList: [],
            showPicker: false,
            workOrder: {
                id: 0,
                cityId: 0,
                projectId: 0,
                content: '',
                projectName: '',
                roomNum: '',
                name: '',
                mobile: '',
                // complaintType: 0,
                image: {
                    associateType: 'WorkOrderImage'
                }
            },
            saving: false,
            memberInfo: {}
        }
    },
    methods: {
        onConfirm(value) {
            this.value = value;
            this.showPicker = false;
        },
        // getOwnerById() {
        //     var vm = this;
        //     abp.ajax.get('/api/services/app/Owner/GetOwnerById?id=' + this.id).then(res => {
        //         this.owner = {
        //             room: {
        //                 project: {}
        //             }
        //         };
        //         this.owner = res.data.result;
        //
        //         vm.workOrder = {
        //             id: 0
        //         };
        //
        //         vm.workOrder.id = 0;
        //
        //         vm.workOrder.cityId = this.owner.room.project.cityId;
        //         vm.workOrder.cityName = this.owner.cityName;
        //
        //         vm.workOrder.projectId = this.owner.projectId;
        //         vm.workOrder.projectName = this.owner.projectName;
        //
        //         vm.workOrder.roomId = this.owner.roomId;
        //         vm.workOrder.roomNum = this.owner.roomNumber;
        //
        //         vm.workOrder.memberId = this.owner.memberId;
        //         vm.workOrder.name = this.owner.name;
        //         vm.workOrder.mobile = this.owner.phoneNumber;
        //
        //         vm.workOrder.content = '';
        //
        //         vm.workOrder.image = {associateType: 'WorkOrderImage'};
        //
        //     }).finally(() => {
        //         // this.loading = false;
        //     });
        // },
        onSave() {
            const vm = this;

            if (!vm.workOrder.name) {
                vm.$toast('请输入联系人');
                return
            }

            if (!vm.workOrder.mobile) {
                vm.$toast('请输入联系电话');
                return
            }
            if (!vm.workOrder.content) {
                vm.$toast('请输入内容');
                return
            }
            vm.workOrder.workOrderType = vm.radio;
            vm.workOrder.source = 0;//微信
            vm.workOrder.dataSource = 2;
            // console.log(vm.workOrder)
            // return;
            vm.saving = true;
            this.$store.dispatch({
                type: 'workOrder/saveWorkOrder',
                data: vm.workOrder
            }).then(() => {
                // vm.$router.replace({path: '/my-complaintRecords/' + vm.workOrder.memberId});
                vm.$router.replace({path: '/my-complaintRecords'});
            }).finally(() => {
                vm.saving = false;
            });
        },
        getMember() {
            const vm = this;
            this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                vm.memberInfo = vm.$store.state.member.memberInfo;

                vm.workOrder.memberId = vm.memberInfo.id;
                vm.workOrder.name = vm.memberInfo.name;
                vm.workOrder.mobile = vm.memberInfo.phoneNumber;

                // localStorage.setItem('MemberId', this.member.id);
            });
        },
        getRoom() {
            const vm = this;
            getRoom(this.id).then(res => {
                vm.roomInfo = {};
                vm.roomInfo = res.data.result;

                vm.workOrder.roomId = vm.roomInfo.id;

                vm.workOrder.cityId = vm.roomInfo.cityId;
                vm.workOrder.cityName = vm.roomInfo.cityName;

                vm.workOrder.projectId = vm.roomInfo.projectId;
                vm.workOrder.projectName = vm.roomInfo.projectName;
                vm.workOrder.roomNum = vm.roomInfo.roomNum;

                vm.workOrder.projectStages = vm.roomInfo.projectStages
                vm.workOrder.roomStructureName = vm.roomInfo.roomStructureName
                vm.workOrder.chamberName = vm.roomInfo.chamberName
                vm.workOrder.storeyName = vm.roomInfo.storeyName
                vm.workOrder.roomNumber = vm.roomInfo.roomNumber

            })
        }
    },
    created() {
        this.getMember();
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            // this.getOwnerById();
            this.getRoom();
        }
    }
}
